<template>
  <section>
    <div class="table-responsive">
      <table class="table table-data">
        <colgroup>
          <col>
          <col width="1">
        </colgroup>
        <thead>
          <tr>
            <th
              class="sm:w-4/6"
              v-text="'Filter'"
            />
            <th
              v-if="showActions"
              class="sm:w-2/6"
              v-text="'Actions'"
            />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="filter in activeFilters"
            :key="`${filter.id}-active-filter`"
          >
            <td v-text="filter.description" />
            <td v-if="showActions">
              <button
                type="button"
                class="btn btn--danger my-2 btn--sm"
                @click="handleDelete(filter.id)"
                v-text="'Remove'"
              />
            </td>
          </tr>
          <tr v-if="showActions">
            <td
              colspan="10"
              class="text-center italic"
            >
              <button
                type="button"
                class="btn btn--border btn--sm my-4"
                @click="$emit('showFilterForm')"
                v-text="addFilterText"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script type="text/babel">
export default {
  name: 'ActiveFilters',
  props: {
    activeFilters: {
      type: Array,
      required: true,
    },
    showActions: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    addFilterText() {
      return this.activeFilters.length === 0
        ? 'Add Filter (optional)'
        : 'Add Another Filter'
    },
  },
  methods: {
    handleDelete(filterId) {
      this.$emit('filterRemoved', {
        id: filterId,
      })
    },
  },
}
</script>
